// extracted by mini-css-extract-plugin
export default {"TicketRow":"styles_TicketRow__NqsOn","Clickable":"styles_Clickable__vhCBh","IconCol":"styles_IconCol__FZDXH","DisabledTicketRow":"styles_DisabledTicketRow__NzYVX"};